__turbopack_context__.v({
  "about": "property1-desktop-module-scss-module__2MJ0Pq__about",
  "aboutParent": "property1-desktop-module-scss-module__2MJ0Pq__aboutParent",
  "aboutSubmenu": "property1-desktop-module-scss-module__2MJ0Pq__aboutSubmenu",
  "agriculture": "property1-desktop-module-scss-module__2MJ0Pq__agriculture",
  "aircraftManagement": "property1-desktop-module-scss-module__2MJ0Pq__aircraftManagement",
  "aircraftSales": "property1-desktop-module-scss-module__2MJ0Pq__aircraftSales",
  "allwights": "property1-desktop-module-scss-module__2MJ0Pq__allwights",
  "antDesigninstagramFilledIcon": "property1-desktop-module-scss-module__2MJ0Pq__antDesigninstagramFilledIcon",
  "availableFleet": "property1-desktop-module-scss-module__2MJ0Pq__availableFleet",
  "blogPress": "property1-desktop-module-scss-module__2MJ0Pq__blogPress",
  "careers": "property1-desktop-module-scss-module__2MJ0Pq__careers",
  "charterFlights": "property1-desktop-module-scss-module__2MJ0Pq__charterFlights",
  "charterFlightsParent": "property1-desktop-module-scss-module__2MJ0Pq__charterFlightsParent",
  "charterQuotes": "property1-desktop-module-scss-module__2MJ0Pq__charterQuotes",
  "charterSubmenu": "property1-desktop-module-scss-module__2MJ0Pq__charterSubmenu",
  "charterheraflightcom": "property1-desktop-module-scss-module__2MJ0Pq__charterheraflightcom",
  "contacts": "property1-desktop-module-scss-module__2MJ0Pq__contacts",
  "contacts1": "property1-desktop-module-scss-module__2MJ0Pq__contacts1",
  "contacts2": "property1-desktop-module-scss-module__2MJ0Pq__contacts2",
  "dot": "property1-desktop-module-scss-module__2MJ0Pq__dot",
  "emptyLegFlights": "property1-desktop-module-scss-module__2MJ0Pq__emptyLegFlights",
  "ezlogz1": "property1-desktop-module-scss-module__2MJ0Pq__ezlogz1",
  "federalLocal": "property1-desktop-module-scss-module__2MJ0Pq__federalLocal",
  "flyHera": "property1-desktop-module-scss-module__2MJ0Pq__flyHera",
  "flyHeraParent": "property1-desktop-module-scss-module__2MJ0Pq__flyHeraParent",
  "foodBeverage": "property1-desktop-module-scss-module__2MJ0Pq__foodBeverage",
  "footerLink": "property1-desktop-module-scss-module__2MJ0Pq__footerLink",
  "footerLinkEzDesc": "property1-desktop-module-scss-module__2MJ0Pq__footerLinkEzDesc",
  "footerLinkEzDescMobile": "property1-desktop-module-scss-module__2MJ0Pq__footerLinkEzDescMobile",
  "footerLinkEzDescMobileParent": "property1-desktop-module-scss-module__2MJ0Pq__footerLinkEzDescMobileParent",
  "footerinfo": "property1-desktop-module-scss-module__2MJ0Pq__footerinfo",
  "footermenu": "property1-desktop-module-scss-module__2MJ0Pq__footermenu",
  "footermenuParent": "property1-desktop-module-scss-module__2MJ0Pq__footermenuParent",
  "headerTop": "property1-desktop-module-scss-module__2MJ0Pq__headerTop",
  "innovatedBy": "property1-desktop-module-scss-module__2MJ0Pq__innovatedBy",
  "inquiriesSales": "property1-desktop-module-scss-module__2MJ0Pq__inquiriesSales",
  "jetCard": "property1-desktop-module-scss-module__2MJ0Pq__jetCard",
  "jetCardParent": "property1-desktop-module-scss-module__2MJ0Pq__jetCardParent",
  "links": "property1-desktop-module-scss-module__2MJ0Pq__links",
  "mail1block": "property1-desktop-module-scss-module__2MJ0Pq__mail1block",
  "mail2block": "property1-desktop-module-scss-module__2MJ0Pq__mail2block",
  "management": "property1-desktop-module-scss-module__2MJ0Pq__management",
  "mdilinkedinIcon": "property1-desktop-module-scss-module__2MJ0Pq__mdilinkedinIcon",
  "passengerBus": "property1-desktop-module-scss-module__2MJ0Pq__passengerBus",
  "phone": "property1-desktop-module-scss-module__2MJ0Pq__phone",
  "phoneLink": "property1-desktop-module-scss-module__2MJ0Pq__phoneLink",
  "phoneblock": "property1-desktop-module-scss-module__2MJ0Pq__phoneblock",
  "primetwitterIcon": "property1-desktop-module-scss-module__2MJ0Pq__primetwitterIcon",
  "privacyPolicy": "property1-desktop-module-scss-module__2MJ0Pq__privacyPolicy",
  "property1desktop": "property1-desktop-module-scss-module__2MJ0Pq__property1desktop",
  "raceTeam": "property1-desktop-module-scss-module__2MJ0Pq__raceTeam",
  "rifacebookFillIcon": "property1-desktop-module-scss-module__2MJ0Pq__rifacebookFillIcon",
  "rightcol": "property1-desktop-module-scss-module__2MJ0Pq__rightcol",
  "schoolBus": "property1-desktop-module-scss-module__2MJ0Pq__schoolBus",
  "section1": "property1-desktop-module-scss-module__2MJ0Pq__section1",
  "section2": "property1-desktop-module-scss-module__2MJ0Pq__section2",
  "services": "property1-desktop-module-scss-module__2MJ0Pq__services",
  "servicesParent": "property1-desktop-module-scss-module__2MJ0Pq__servicesParent",
  "servicesSubmenu": "property1-desktop-module-scss-module__2MJ0Pq__servicesSubmenu",
  "socialIcons": "property1-desktop-module-scss-module__2MJ0Pq__socialIcons",
  "socialLink": "property1-desktop-module-scss-module__2MJ0Pq__socialLink",
  "socials": "property1-desktop-module-scss-module__2MJ0Pq__socials",
  "subFooter": "property1-desktop-module-scss-module__2MJ0Pq__subFooter",
  "termsConditions": "property1-desktop-module-scss-module__2MJ0Pq__termsConditions",
  "topblock": "property1-desktop-module-scss-module__2MJ0Pq__topblock",
  "vipheraflightcom": "property1-desktop-module-scss-module__2MJ0Pq__vipheraflightcom",
});
